/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useSelector } from "react-redux";

import { useAppDispatch } from "../../../store/rootStore";
import { ProductDetailsApiResponse } from "../../products/storage";
import { selectStockIds, StocksSlice } from "../../products/storage/stocks.slice";
import { fetchProductDetail } from "../../products/utils/fetchProductDetail";

export const useCheckLocalStorage = () => {
  const ids = useSelector(selectStockIds);
  const dispatch = useAppDispatch();

  const checkSeedInLocalStorage = async (
    productIds: number[],
    accountNumber: string,
    branchId: string | undefined
  ) => {
    const tasks: Promise<ProductDetailsApiResponse>[] = [];
    productIds.forEach((id) => {
      if (!ids.includes(id.toString())) {
        tasks.push(fetchProductDetail(id.toString(), accountNumber, branchId));
      }
    });
    const results = await Promise.all(tasks);
    dispatch(StocksSlice.actions.addStockArray(results));
  };

  return { checkSeedInLocalStorage };
};
